/**
 * "Made to solve" — cycles through the configured icon/text tags inside
 * each .made-to-solve__rotator on the page, sliding the outgoing tag up
 * and off while the next tag slides up into view from the bottom.
 * Blank tags (merchant left the text empty) are skipped since the Liquid
 * template only renders tags that have text.
 */
(function () {
  'use strict';

  var rotators = document.querySelectorAll('.made-to-solve__rotator');
  if (!rotators.length) return;

  rotators.forEach(function (rotator) {
    var tags = Array.prototype.slice.call(rotator.querySelectorAll('.made-to-solve__tag'));
    if (!tags.length) return;

    sizeRotator(rotator, tags);

    tags[0].classList.add('is-active');
    if (tags.length < 2) return;

    var intervalMs = parseInt(rotator.getAttribute('data-rotate-speed'), 10) || 2000;
    var animationMs = parseInt(rotator.getAttribute('data-animation-speed'), 10) || 400;
    var index = 0;

    setInterval(function () {
      var current = tags[index];
      var nextIndex = (index + 1) % tags.length;
      var next = tags[nextIndex];

      current.classList.remove('is-active');
      current.classList.add('is-leaving');
      next.classList.add('is-active');

      // Once the outgoing tag has finished sliding off the top, drop it
      // back to its default "waiting below" position so it's ready to
      // slide back in next time it's due.
      window.setTimeout(function () {
        current.classList.remove('is-leaving');
      }, animationMs);

      index = nextIndex;
    }, intervalMs);
  });

  function sizeRotator(rotator, tags) {
    var maxWidth = 0;
    var maxHeight = 0;

    tags.forEach(function (tag) {
      var clone = tag.cloneNode(true);
      clone.style.position = 'static';
      clone.style.opacity = '0';
      clone.style.transform = 'none';
      clone.style.transition = 'none';
      clone.classList.add('is-active');
      clone.classList.remove('is-leaving');
      rotator.appendChild(clone);
      var rect = clone.getBoundingClientRect();
      maxWidth = Math.max(maxWidth, rect.width);
      maxHeight = Math.max(maxHeight, rect.height);
      rotator.removeChild(clone);
    });

    if (maxWidth) rotator.style.width = Math.ceil(maxWidth) + 'px';
    if (maxHeight) rotator.style.height = Math.ceil(maxHeight) + 'px';
  }
})();